var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "form",
        {
          ref: "createPostForm",
          staticClass: "form create-post",
          class: { "is-editing": _vm.isEditing },
          attrs: { novalidate: "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSubmit.apply(null, arguments)
            },
          },
        },
        [
          _vm.errors && _vm.errors.length
            ? _c("ValidationAlert", {
                attrs: { "error-list": _vm.errors.collect("server") },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "create-post__content" },
            [
              _vm.user
                ? _c("img", {
                    staticClass: "avatar",
                    attrs: { src: `/images/avatar/${_vm.user.id}`, alt: "" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("TextareaWithMentions", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                ref: "postContent",
                attrs: {
                  "default-value": _vm.formData.post_content,
                  "field-name": "post_content",
                },
                model: {
                  value: _vm.formData.post_content,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "post_content", $$v)
                  },
                  expression: "formData.post_content",
                },
              }),
              _vm._v(" "),
              !_vm.isEditing
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn--icon btn--primary",
                      attrs: { disabled: _vm.$wait.is("creating_post") },
                    },
                    [
                      _vm.$wait.is("creating_post")
                        ? _c("Spinner")
                        : _c("SvgIcon", {
                            attrs: { icon: "filled-send", classes: "filled" },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "form__validation" }, [
            _vm._v(_vm._s(_vm.errors.first("post_content"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "create-post__actions" },
            [
              _c("ToggleButton", {
                attrs: {
                  icon: "filled-img",
                  "icon-filled": true,
                  label: "Add Image",
                  "is-active": _vm.extraState.imageOpen,
                  "is-disabled": !!_vm.extraState.selectedRelated,
                },
                on: {
                  click: function ($event) {
                    _vm.extraState.imageOpen = !_vm.extraState.imageOpen
                  },
                },
              }),
              _vm._v(" "),
              _c("ToggleButton", {
                attrs: {
                  icon: "filled-file",
                  "icon-filled": true,
                  label: "Add Files",
                  "is-active": _vm.extraState.attachmentsOpen,
                  "is-disabled": !!_vm.extraState.selectedRelated,
                },
                on: {
                  click: function ($event) {
                    _vm.extraState.attachmentsOpen =
                      !_vm.extraState.attachmentsOpen
                  },
                },
              }),
              _vm._v(" "),
              _c("ToggleButton", {
                attrs: {
                  icon: "filled-oppomadd",
                  "icon-filled": true,
                  label: "Link MADD/Opportunity",
                  "is-active": !!_vm.extraState.selectedRelated,
                },
                on: { click: _vm.handleSearch },
              }),
              _vm._v(" "),
              _c("ToggleButton", {
                attrs: {
                  icon: "filled-sector",
                  "icon-filled": true,
                  label: "Add Subsector",
                  "is-active": _vm.extraState.sectorOpen,
                  "is-disabled": !!_vm.extraState.selectedRelated,
                },
                on: {
                  click: function ($event) {
                    _vm.extraState.sectorOpen = !_vm.extraState.sectorOpen
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          Object.values(_vm.extraState).filter(Boolean).length
            ? _c("div", { staticClass: "create-post__extra" }, [
                _vm.extraState.imageOpen
                  ? _c(
                      "div",
                      { staticClass: "form__fieldset" },
                      [
                        _c("FileUpload", {
                          ref: "imageUpload",
                          attrs: {
                            id: "image",
                            label: "Image",
                            name: "image",
                            "file-types": "image/*",
                            multiple: false,
                          },
                          model: {
                            value: _vm.formData.image,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "image", $$v)
                            },
                            expression: "formData.image",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.extraState.attachmentsOpen
                  ? _c(
                      "div",
                      { staticClass: "form__fieldset" },
                      [
                        _c("FileUpload", {
                          ref: "fileUpload",
                          attrs: {
                            id: "files",
                            name: "files",
                            label:
                              "Upload files relevant to this sector to share them with the rest of the team:",
                            multiple: true,
                          },
                          model: {
                            value: _vm.formData.files,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "files", $$v)
                            },
                            expression: "formData.files",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.extraState.selectedRelated
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "form__group" },
                        [
                          _c("span", { staticClass: "form__label" }, [
                            _vm._v("MADD/Opportunity"),
                          ]),
                          _vm._v(" "),
                          _c("SelectedResult", {
                            attrs: {
                              item: _vm.extraState.selectedRelated,
                              "has-remove": true,
                            },
                            on: { remove: _vm.handleRelatedRemove },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.extraState.sectorOpen
                  ? _c(
                      "div",
                      { staticClass: "form__fieldset" },
                      [
                        _c("FormControlDynamicSector", {
                          ref: "sectorDropdown",
                          attrs: {
                            name: "sectors",
                            "default-value": _vm.formData.sectors,
                            "default-items": _vm.formData.sectorOptions,
                            "parent-sector-id": _vm.sectorId,
                            options: { openDirection: "below" },
                          },
                          model: {
                            value: _vm.formData.sectors,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "sectors", $$v)
                            },
                            expression: "formData.sectors",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isEditing
            ? _c(
                "button",
                {
                  staticClass: "btn btn--outline",
                  attrs: { id: "update-button" },
                },
                [
                  _vm.$wait.is("creating_post")
                    ? _c("Spinner", {
                        attrs: { color: "#fff", width: 18, height: 18 },
                      })
                    : _c("span", [_vm._v("Update Post")]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        { attrs: { name: "related-item-search" } },
        [
          _c("SearchModalForm", {
            attrs: { sectorId: _vm.sectorId },
            on: { change: _vm.handleRelatedSelection },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }